import cn from "classnames";
import without from "lodash/without";
import React, { useState } from "react";

export default function RelayIds(props) {
    const [id, setId] = useState("");

    const removeRelay = (id) => {
        const newValue = without(props.values, id);
        props.setValue({ name: "relayIds", value: newValue });
    };

    const addRelay = () => {
        if (!id || props.values.indexOf(id) !== -1) {
            return;
        }
        props.setValue({ name: "relayIds", value: [...props.values, id] });
        setId("");
    };

    return (
        <div className="row form-group field-wrap--value">
            <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left">
                ID ретрансляторов
            </label>
            <div className="col-sm-8 col-md-9">
                <label className="col-form-label col-form-label-sm">
                    {props.values.map((item) => (
                        <span key={item} className="badge badge-pill badge-secondary mr-1 font-size-12">
                            {item}
                            &nbsp;
                            <span className="text-danger cursor-pointer" onClick={() => removeRelay(item)}>
                                &times;
                            </span>
                        </span>
                    ))}
                    <div className="pt-1 d-flex">
                        <input
                            className="form-control form-control-xs"
                            onChange={(e) => setId(e.target.value)}
                            value={id}
                        />
                        <div className={cn("btn btn-xs btn-brand ml-1", { disabled: !id })} onClick={addRelay}>
                            Добавить
                        </div>
                    </div>
                </label>
            </div>
        </div>
    );
}
